import { IconAlert, IconX } from "../components/icons";
import { Button } from "../components/ui";
import { useI18n } from "../i18n";
import type { MessageKey } from "../i18n/strings";
import { PageShell } from "./PageShell";

/**
 * Full-page error. `kind` picks the wording: "payment" for invoice links (default), "link" for the
 * other public links (billing, subscription, refund, top-up, payment link).
 */
export function ErrorState({ code, onRetry, kind = "payment" }: { code: string; onRetry?: () => void; kind?: "payment" | "link" }) {
  const { t } = useI18n();
  const notFound = code === "not_found";
  const rate = code === "rate_limited" || code === "http_429";
  let title: MessageKey;
  let body: MessageKey;
  if (code === "link_inactive") [title, body] = ["link.inactiveTitle", "link.inactiveBody"];
  else if (notFound) [title, body] = kind === "link" ? ["error.linkTitle", "error.linkBody"] : ["error.notFoundTitle", "error.notFoundBody"];
  else if (rate) [title, body] = ["error.rateTitle", "error.rateBody"];
  else [title, body] = ["error.networkTitle", "error.networkBody"];
  const neutral = notFound || code === "link_inactive";
  return (
    <PageShell narrow>
      <main className="center-card panel" id="main">
        <span className={`result-icon ${neutral ? "result-icon-neutral" : "result-icon-warning"}`} aria-hidden="true">
          {neutral ? <IconX size={26} /> : <IconAlert size={26} />}
        </span>
        <h1 className="h1">{t(title)}</h1>
        <p className="muted">{t(body)}</p>
        {!neutral && onRetry ? (
          <Button variant="secondary" onClick={onRetry}>
            {t("common.retry")}
          </Button>
        ) : null}
        {!neutral && !rate && code !== "network" ? <p className="muted small mono">{code}</p> : null}
      </main>
    </PageShell>
  );
}
